import http from '@/utils/http'
const host = 'https://app.qudao51.com/'
// const host = 'https://tdapp.qudao51.cn/'


// 获取视频分享信息
const getVideoInfo=(params)=>http.get(host+'exp-shop/video-shop/recommend/getData',{params})
// 获取直播分享信息
const getOnliveInfo=(params)=>http.get(host+'exp-shop/body/expShopLive/getExploreShopNo/v1?exploreShopNo',{params})
// 分享签名
const shareSign=(params)=>http.post(host+'agent/other/agent/get/sign',params)
// 安卓下载链接
const androidUrl=(params)=>http.get(host+'exp-shop/system/web/get/version/v1?productType=0',{params})
// 举报上传图片
const uploadImage=(params)=>http.post(host+'exp-shop/report/upload/image',params, {
	header: {
		"Content-Type":"application/x-www-form-urlencoded"
	}
})
// 举报接口
const tipoff=(params)=>http.post(host+'exp-shop/report/reportPost/v1',params)
// 小店-图片上传
const picUpload =(params)=>http.post(host+'exp-shop/store/picUpload',params, {
	header: {
		"Content-Type":"application/x-www-form-urlencoded"
	}
})
// 获取经营类目列表接口
const listBusinessScope =(params)=>http.get(host+'exp-shop/store/listBusinessScope',{params})
// 获取验证码
const getVerifyCode =(params)=>http.get(host+'common/qdwy-other/code/v1',{params})
// 提交审核
const submitAudit =(params)=>http.post(host+'exp-shop/store/apply',params)
// 获取审核信息
const getByUser =(params)=>http.get(host+'exp-shop/store/getByUser',{params})
// 编辑审核
const submitAgain =(params)=>http.post(host+'exp-shop/store/editApply',params)
export{
  getVideoInfo,
  shareSign,
  androidUrl,
  uploadImage,
  tipoff,
  getOnliveInfo,
  picUpload,
  listBusinessScope,
  getVerifyCode,
  submitAudit,
  getByUser,
  submitAgain
}